import { LandingTranslationType } from "../../features/landing.types";

export const landing: LandingTranslationType = {
  landing: {
    hero: {
      title: "Crea tu historia con IA",
      subtitle: "Donde la imaginación se encuentra con la inteligencia artificial",
      description: "Utiliza nuestra plataforma interactiva de narración asistida por IA para crear historias y personajes cautivadores",
      startStory: "Comienza tu historia",
      signIn: "Iniciar sesión"
    },
    features: {
      title: "Libera tu creatividad",
      aiPowered: {
        title: "Historias impulsadas por IA",
        description: "Crea narrativas únicas con nuestro avanzado motor de narración de IA"
      },
      interactiveChoices: {
        title: "Elecciones interactivas",
        description: "Dale forma a tu historia a través de decisiones significativas y acciones personalizadas"
      },
      creativeFreedom: {
        title: "Libertad creativa",
        description: "Escribe tu propio camino con posibilidades creativas ilimitadas"
      }
    },
    preview: {
      title: "Vista previa de una historia",
      storyText: "La antigua puerta se abrió con un chirrido, revelando una cámara bañada en luz azul etérea. Formaciones de cristal sobresalían de las paredes, sus superficies reflejando innumerables pequeños arcoíris por toda la habitación. En el centro, flotando a centímetros sobre un pedestal de mármol negro, había un libro encuadernado en lo que parecía ser luz estelar...",
      whatToDo: "¿Qué haces?",
      choice1: "Acercarse al libro con cautela, estudiando la habitación en busca de trampas",
      choice2: "Usar tu magia para detectar encantamientos peligrosos",
      choice3: "¡Agarrar el libro con valentía - la fortuna favorece a los valientes!"
    },
    storyPreview: {
      header: "Experimenta la Narración Inmersiva",
      description: "Crea, explora y da forma a historias en un entorno interactivo dinámico con {{appName}}",
      genres: "Géneros",
      themes: "Temas",
      environment: "Entorno",
      writeResponse: "Escribe tu propia respuesta...",
      previousStory: "Historia anterior",
      nextStory: "Siguiente historia",
      goToStory: "Ir a la historia {{number}}"
    },
    callToAction: {
      title: "¿Listo para comenzar tu viaje?",
      subtitle: "Únete a miles de narradores creando aventuras únicas con IA",
      button: "Empieza a escribir ahora"
    },
    creativeSuite: {
      title: "Suite Creativa",
      description: "Herramientas poderosas para desbloquear tu potencial narrativo y dar vida a tu imaginación",
      categories: {
        stories: "Historias",
        characters: "Personajes",
        premium: "Premium"
      },
      premiumFeature: "Función Premium",
      basicFeature: "Disponible en Plan Básico",
      freeFeature: "Gratis para todos",
      getStarted: "Comenzar",
      noCreditCard: "No se requiere tarjeta de crédito para comenzar tu viaje creativo",
      tools: {
        aiWriting: {
          title: "Escritura Impulsada por IA",
          description: "Crea historias de elige-tu-propia-aventura con IA avanzada. Avanza con respuestas sugeridas o escribe las tuyas."
        },
        genresThemes: {
          title: "Géneros, Temas y Entornos Extensos",
          description: "Como usuario gratuito, accede a un conjunto limitado de géneros, o desbloquea todos los géneros y temas con el plan Básico."
        },
        sequels: {
          title: "Secuelas y Series de Historias",
          description: "Continúa tus mejores historias con secuelas y construye series de historias atractivas."
        },
        characterBuilder: {
          title: "Constructor de Personajes",
          description: "Diseña personajes complejos con personalidades detalladas, motivaciones e historias de fondo."
        },
        aiPortraits: {
          title: "Retratos de Personajes con IA",
          description: "Genera representaciones visuales únicas de tus personajes con nuestro generador de retratos con IA."
        },
        characterExtract: {
          title: "Extracción de Personajes",
          description: "Extrae personajes de tus historias automáticamente para construir tu biblioteca de personajes."
        },
        sharing: {
          title: "Compartir y Publicar Historias",
          description: "Comparte tus historias y hazlas públicas para que otros las disfruten y aprecien."
        },
        unlimitedStorage: {
          title: "Límite de Historias Aumentado",
          description: "Crea hasta 5 historias por día con el plan Gratuito, 25 con el Básico, o historias ilimitadas con Premium."
        },
        statsBadges: {
          title: "Estadísticas e Insignias",
          description: "Rastrea tus estadísticas de escritura y gana insignias por tus logros narrativos."
        }
      }
    },
    exampleStories: {
      dragonsRiddle: {
        title: "El Acertijo del Dragón",
        excerpt: "El antiguo dragón planteó un acertijo que había permanecido sin resolver durante siglos. \"Responde correctamente\", gruñó, \"y te concederé paso a través de la montaña\". Las escamas de la enorme criatura brillaban como obsidiana en la tenue luz de la caverna. Me quedé allí, con las yemas de los dedos temblando contra la fría piedra, mis compañeros inmóviles detrás de mí. Los ojos ámbar del dragón se fijaron en los míos. \"Pero si fallas\", continuó la bestia, \"te unirás a los huesos de los que vinieron antes\". Señaló restos dispersos que había intentado no notar. A los dragones les gustaban los juegos de palabras y los significados ocultos. El destino de nuestra búsqueda dependía de mi capacidad para descifrar el enigma de la criatura.",
        suggestion1: "\"La respuesta es 'el tiempo': devora todo, pero nunca se consume\", proclamé con más confianza de la que sentía.",
        suggestion2: "Me incliné respetuosamente ante la antigua bestia. \"Gran ser, ¿puedo hacer una pregunta aclaratoria sobre tu acertijo?\"",
        suggestion3: "Miré los rostros temerosos de mis compañeros antes de volver al dragón. \"¿Quizás podríamos negociar otra forma de pasar?\""
      },
      echoesFromTomorrow: {
        title: "Ecos del Mañana",
        excerpt: "La Dra. Miranda Chen miraba fijamente el mensaje en su pantalla. Había llegado ayer, pero la marca de tiempo mostraba que fue enviado mañana. Lo leyó de nuevo: \"Protocolo Omega iniciado. NO continúes con la secuencia de prueba. Colapso temporal catastrófico inminente\". Miranda revisó el conjunto de comunicación cuántica que había diseñado—estaba destinado a reducir la latencia de señal, no a atravesar el velo entre el ahora y el mañana. Las firmas cuánticas integradas en el mensaje coincidían exactamente con sus protocolos de encriptación, con una anomalía imposible: mostraban patrones de deterioro que aún no podían existir. Mientras su terminal sonaba con otro mensaje entrante, Miranda sintió un escalofrío. La identificación del remitente mostraba su propio nombre.",
        suggestion1: "Miranda escribió rápidamente: \"Habla la Dra. Chen. Identifíquese y explique cómo está accediendo a nuestros sistemas seguros\".",
        suggestion2: "Inició un apagado de emergencia mientras respaldaba todos los datos del proyecto en el servidor externo seguro.",
        suggestion3: "Llamó a su compañero de investigación: \"Kenji, algo imposible está sucediendo con el conjunto cuántico\"."
      },
      forgottenLibrary: {
        title: "La Biblioteca Olvidada",
        excerpt: "La biblioteca aparecía solo en noches lluviosas, sus puertas abriéndose a quienes más necesitaban respuestas. Había estado buscándola durante años, siguiendo rumores y referencias oscuras. Ahora, mientras me encontraba ante su imposible arquitectura—más grande por dentro que por fuera—dudé. Las enormes puertas de roble estaban ligeramente entreabiertas, la cálida luz derramándose sobre los adoquines mojados. El vestíbulo se elevaba imposiblemente alto, con estanterías que se extendían más allá de donde debería estar el techo. El aire olía a papel, tinta y algo más antiguo—como si el tiempo mismo tuviera un aroma. Noté que los susurros se hacían más fuertes, provenientes de miles de libros hablando a la vez. Entonces, una voz se elevó por encima de las demás: \"Te hemos estado esperando\".",
        suggestion1: "\"¿Quién está ahí?\", grité, mi voz haciendo eco a través del cavernoso espacio mientras escudriñaba los pasillos sombríos.",
        suggestion2: "Me acerqué a la estantería más cercana y pasé mis dedos por los antiguos lomos, preguntándome qué libro había hablado.",
        suggestion3: "\"He venido buscando información sobre la Convergencia Celestial\", anuncié a la biblioteca susurrante."
      }
    }
  }
};
